<template>
  <div>
    <ProductHeader :productSelected="productSelected" />
    <v-row>
      <v-col cols="12" md="7">
        <ProductImage
          :productSelected="productSelected"
          :pageOrigin="pageOrigin"
        />
      </v-col>
      <v-col cols="12" md="5">
        <v-row>
          <v-col cols="12" md="10">
            <label class="text-h6">{{ productSelected.name }}</label>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn
              color="black"
              outlined
              @click="goToBackPage()"
              left
              small
              dark
              style="float: right"
            >
              <v-icon left>mdi-chevron-left</v-icon>
              Voltar
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <ProductDetails :productSelected="productSelected" />
        </v-row>
        <ProductAnotherColors
          :productSelected="productSelected"
          :products="products"
          :showAnotherProduct="showDetailsProduct"
        />
        <StockInfo
          v-if="pageOrigin === 'express'"
          :sizes="productSelected.grid"
          :stock="productSelected.stock"
        />
        <v-row>
          <v-col class="mt-3 pt-2">
            <label class="text-h6 text-weight-black">Tamanhos</label>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mt-0 pt-0">
            <div
              v-for="(size, idx) in productSelected.grid"
              :key="size"
              style="width: 50px; float: left; margin-right: 5px"
              class="py-0"
            >
              <label style="padding-left: 15px">{{ size }}</label>
              <v-text-field
                outlined
                dense
                hide-details
                v-model="productSelected.qtys[idx]"
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <label class="text-h5">
              {{ productSelected.price_cif | currencyEuaToBr }}
            </label>
          </v-col>
        </v-row>
        <v-row v-if="false">
          <v-col>
            <v-alert
              border="left"
              color="red lighten-2"
              dark
              dense
              icon="mdi-alert"
              text
            >
              <label class="font-weight-bold">
                Este produto não é da coleção atual, sujeito a alteração de
                preço e disponibilidade.
              </label>
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn @click="addToCart()" color="green" dark>
              <v-icon left>mdi-cart-outline</v-icon>
              Adicionar ao Carrinho
            </v-btn>
          </v-col>
        </v-row>
        <ProductTechnicalDetails :productSelected="productSelected" />
        <ProductTechnologies :productSelected="productSelected" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ProductImage from "@/components/Book/ProductImage";
import ProductHeader from "@/components/Book/ProductHeader";
import ProductDetails from "@/components/Book/ProductDetails";
import ProductAnotherColors from "@/components/Book/ProductAnotherColors";
import ProductTechnicalDetails from "@/components/Book/ProductTechnicalDetails";
import ProductTechnologies from "@/components/Book/ProductTechnologies";
import StockInfo from "@/components/Express/StockInfo.vue";

export default {
  props: {
    productSelected: {},
    products: [],
    pageOrigin: {
      type: String,
      default: "book",
    },
    showDetailsProduct: Function,
    goToBackPage: Function,
    addToCart: Function,
  },
  components: {
    ProductImage,
    ProductHeader,
    ProductDetails,
    ProductAnotherColors,
    ProductTechnicalDetails,
    ProductTechnologies,
    StockInfo,
  },
};
</script>
